// Content & media mirrored from https://www.kia.com/in/our-vehicles/sorento/showroom.html
const KIA = "https://www.kia.com/content/dam/kia2/in/en";
const SHOWROOM = `${KIA}/images/our-vehicles/sonetro/showroom`;
const TEASER = `${KIA}/images/our-vehicles/sonetro/teaser`;

const BrochureLink = `${SHOWROOM}/The_Kia_Sorento_Brochure_D.pdf`;

const BannerData = {
  videoUrl: `${SHOWROOM}/1920X1080-d.mp4`,
  mobileVideoUrl: `${SHOWROOM}/1080X1980-m.mp4`,
  title: "The Kia Sorento",
  subtitle: "Global Icon. Reimagined for India.",
  price: "₹ 27,99,000#",
  features: [],
};

const LifestyleImage = {
  imageUrl: `${SHOWROOM}/sorento_life_d.jpeg`,
  mobileImageUrl: `${SHOWROOM}/sorento_life_m.png`,
  alt: "A Kia Sorento in Dark Gun Metal (Matte) shown from the front three-quarter view at a premium waterfront residence.",
};

const HighlightsData = {
  eyebrow: "HIGHLIGHTS",
  heading: "Designed For Every Drive",
  description: "Unmatched Features. Unrivaled Experience.",
  items: [
    {
      title: "Kia AI Assistant: Adaptive Intelligence That Moves With You.",
      description:
        "With Real-Time Generative AI capabilities, the Kia AI Assistant understands your questions, responds conversationally and guides you seamlessly through your journey.",
      media: `${SHOWROOM}/Kia-Ai-Assistance.png`,
    },
    {
      title: "HEV: Driven by Power. Defined by Efficiency.",
      description:
        "The Smartstream 1.6 Turbo GDi Hybrid engine seamlessly balances turbocharged performance and electric assistance, giving you responsive power, greater efficiency and a smooth, composed drive.",
      media: `${SHOWROOM}/feature-02.png`,
    },
    {
      title: "AWD: Intuitive Technology. Ready For What’s Next.",
      description:
        "All-Wheel Drive enhances traction and stability by distributing power across all four wheels, giving you greater control and confidence wherever the road takes you.",
      media: `${SHOWROOM}/All-Wheel-Drive.png`,
    },
  ],
};

const CircleData = [
  {
    title: "Aurora Black Pearl",
    color: "#151617",
    imgSrc: `${KIA}/images/360vr/sorento/5gw72hc5npp021/exterior/abp/09-d.png`,
  },
];

const ExploreVideoData = {
  eyebrow: "EXPLORE",
  videoUrl: `${SHOWROOM}/1920960.mp4`,
  features: [
    {
      label: "Crystal Cube MFR LED Headlamps with Auto Light Control",
      description:
        "Experience superior night vision and dynamic clarity that automatically adjusts to your surroundings.",
      start: 1.5,
      end: 3.5,
    },
    {
      label: "Smart Power Tailgate with Anti-Pinch Function",
      description:
        "Enjoy seamless hands-free convenience coupled with intelligent protection against accidental closure.",
      start: 8,
      end: 12,
    },
    {
      label: "Driver Seat Ergo Function",
      description:
        "Indulge in personalized ergonomic comfort that keeps you refreshed through every single mile.",
      start: 16.5,
      end: 20,
    },
    {
      label: "Dial-Type Shift-by-Wire Selector",
      description:
        "Unlock smooth, precise gear selection right at your fingertips with modern simplicity.",
      start: 23.5,
      end: 26,
    },
    {
      label: "Kia AI Assistant",
      description:
        "Experience smart, natural conversation that provides real-time answers and seamless journey management.",
      start: 27.8,
      end: 30,
    },
    {
      label: "Advanced Digital IRVM (Inside Rear View Mirror)",
      description:
        "Get a crystal-clear, unobstructed rear view regardless of passengers or low-light conditions.",
      start: 32.5,
      end: 34,
    },
  ],
};

const ExteriorShowcase = {
  eyebrow: "EXTERIOR",
  heading: "Designed to Dominate Every Road",
  slides: [
    {
      image: `${SHOWROOM}/ext/DualPanePanoramicSunroof.png`,
      title: "Dual Pane Panoramic Sunroof",
      subtitle:
        "Let more light into every journey and enjoy a wider view. Sit back, look up and make every drive feel more open.",
    },
    {
      image: `${SHOWROOM}/ext/GreyGrilleMesh.png`,
      title: "Kia Digital Tiger Face",
      subtitle:
        "The iconic Digital Tiger Face evolves with a bold, contemporary design, giving Sorento a distinctive presence that commands attention from every angle.",
    },
    {
      image: `${SHOWROOM}/ext/RearCombiTaillight.png`,
      title: "Starmap LED Tail Lamps",
      subtitle:
        "A distinctive lighting signature that enhances its bold rear profile. Designed to make every arrival stand out, day or night.",
    },
    {
      image: `${SHOWROOM}/ext/SharkFinAntenna.png`,
      title: "Integrated Rear Spoiler with Hidden Wiper",
      subtitle:
        "Thoughtfully integrated into the rear spoiler, the hidden wiper keeps the design clean, contemporary and beautifully uninterrupted.",
    },
    {
      image: `${SHOWROOM}/ext/Escort.png`,
      title: "LED 4 Cube Projector Headlamp With Auto Light Control",
      subtitle:
        "See the road ahead with greater clarity and confidence. Automatic control makes every drive more effortless, day or night.",
    },
    {
      image: `${SHOWROOM}/ext/Door_Handle.png`,
      title: "Grab Handles with Touch Sensor & Pocket Lighting",
      subtitle:
        "A seamless detail that blends effortlessly with the exterior. Designed to keep the look clean, refined and cohesive.",
    },
    {
      image: `${SHOWROOM}/ext/Black_bridge.png`,
      title: "High Glossy Black Bridge Type Roof-rails",
      subtitle:
        "A bold detail that adds character to the Sorento’s silhouette. Designed to complement its confident, adventure-ready stance.",
    },
    {
      image: `${SHOWROOM}/ext/CrystalCutAlloys.png`,
      title: "R19- 48.2 cm (19”) Premium Crystal Cut Alloy Wheels",
      subtitle:
        "Sharp, distinctive and designed to catch your eye. A refined touch that adds even more character to every drive.",
    },
  ],
};

const InteriorShowcase = {
  eyebrow: "INTERIOR",
  heading: "Interiors That Make Every Drive Feel Better",
  slides: [
    {
      image: `${SHOWROOM}/int/slide-1.png`,
      title: "31.24cm (12.3”) HD Display Instrument Cluster with Head-up Display Unit",
      subtitle:
        "Stay informed with clarity, right in your line of sight. The HD cluster and Head-Up Display keep essential information effortlessly within view.",
    },
    {
      image: `${SHOWROOM}/int/SpeakersSystem.png`,
      title: "Bose Premium Sound System with 12 Speakers",
      subtitle:
        "Bring every song, voice and conversation to life. A rich, immersive sound experience that makes every drive more enjoyable.",
    },
    {
      image: `${SHOWROOM}/int/slide-5.png`,
      title: "Dual Zone Automatic Temperature Control",
      subtitle:
        "Set your comfort, your way, across both sides of the cabin. Dual-zone automatic temperature control keeps everyone comfortable throughout the journey.",
    },
    {
      image: `${SHOWROOM}/int/RelaxationRow_Seats.png`,
      title: "1st Row Relaxation Comfort Seats",
      subtitle:
        "Sit back, relax and let the journey unfold. Relaxation seats are designed to give you greater comfort, mile after mile.",
    },
    {
      image: `${SHOWROOM}/int/slide-2.png`,
      title: "31.24cm (12.3”) HD Touchscreen Navigation Cockpit",
      subtitle:
        "Stay connected and on course, wherever the road takes you. A clear, intuitive display puts navigation and essential information right at your fingertips.",
    },
    {
      image: `${SHOWROOM}/int/InfotainmentTemperature.png`,
      title: "Infotainment- Temperature Control Swap Switch",
      subtitle:
        "Switch between infotainment and temperature controls with ease. Everything you need is just a touch away, keeping you comfortably in control.",
    },
    {
      image: `${SHOWROOM}/int/slide-6.png`,
      title: "64 Color Ambient Lighting",
      subtitle:
        "Set the mood to match every journey. 64-colour ambient lighting adds a personalised touch to the cabin, day or night.",
    },
    {
      image: `${SHOWROOM}/int/10-Way-Power-Driver-Seat.png`,
      title: "10 Way Power Driver Seat With Ergo Motion",
      subtitle:
        "Find your perfect driving position with ease. 10-way power adjustment and Ergo Motion deliver personalised support and lasting comfort.",
    },
    {
      image: `${SHOWROOM}/int/67Seater.png`,
      title: "6 or 7-Seater Variants",
      subtitle:
        "Select your ideal seating arrangement with 6 or 7-seater options to enjoy premium space, ultimate versatility, and superior comfort on every single road.",
    },
  ],
};

const SafetyShowcase = {
  eyebrow: "SAFETY",
  heading: "Safety You Can Count On",
  slides: [
    {
      image: `${SHOWROOM}/saf/10-Airbags.png`,
      title: "10 Airbags",
      subtitle:
        "Greater protection for you and your loved ones on every journey. Ten airbags add an extra layer of confidence when it matters most.",
    },
    {
      image: `${SHOWROOM}/saf/ESCstandard.png`,
      title: "ESC, HAC & VSM as standard",
      subtitle:
        "Stay steady and in control, whatever the road brings. Smart stability features work together to give you greater confidence behind the wheel.",
    },
    {
      image: `${SHOWROOM}/saf/Solar-Acoustic.png`,
      title: "Solar & Acoustic Windshield",
      subtitle:
        "Enjoy a cooler, quieter cabin as you travel. Designed to keep outside heat and noise where they belong, outside.",
    },
    {
      image: `${SHOWROOM}/saf/360degreecamera.png`,
      title: "360-degree Camera",
      subtitle:
        "Get a clearer view of what’s around you, wherever you’re headed. Enhanced visibility makes parking and manoeuvring feel more confident and effortless.",
    },
    {
      image: `${SHOWROOM}/saf/SmartPowerTailgate.png`,
      title: "Smart Power Tailgate",
      subtitle:
        "Open up convenience whenever you need it. Hands-free access makes loading and unloading your essentials effortless.",
    },
    {
      image: `${SHOWROOM}/saf/parkingsensor.png`,
      title: "12 Parking Sensor with 5 Radars",
      subtitle:
        "Stay aware of your surroundings with advanced sensing technology for easier, safer and more confident parking.",
    },
  ],
};

const ComfortShowcase = {
  eyebrow: "COMFORT",
  heading: "A refined driving experience that keeps you comfortable, wherever you go.",
  slides: [
    {
      image: `${SHOWROOM}/comf/Winge_Headrest.png`,
      title: "Wing Type Headrest for Captain Seats (6S)",
      subtitle:
        "Settle in and enjoy a more comfortable drive. Designed to provide added support, so you can relax throughout the journey.",
    },
    {
      image: `${SHOWROOM}/comf/Ventilated1-2Row.png`,
      title: "1st & 2nd Row Ventilated Seats",
      subtitle:
        "Stay cool and comfortable, wherever you’re seated. Enjoy a more refreshing journey, even on warmer days.",
    },
    {
      image: `${SHOWROOM}/comf/ErgoMotionDriverSeat.png`,
      title: "Driver Seat- Ergo Motion",
      subtitle:
        "Settle into a position that feels right for you. Ergo Motion adapts to your body, helping you stay comfortable and supported throughout the drive.",
    },
    {
      image: `${SHOWROOM}/comf/10-WayPowerFrontSeats.png`,
      title: "10-Way Power Driver Seat with Lumbar Adjust",
      subtitle:
        "With 10-way power adjustment and lumbar support, the driver’s seat adapts to your preferences for a more personalised driving experience.",
    },
    {
      image: `${SHOWROOM}/int/RelaxationRow_Seats.png`,
      title: "1st Row Relaxation Comfort Seats",
      subtitle:
        "Sit back, relax and let the journey unfold. Relaxation seats are designed to give you greater comfort, mile after mile.",
    },
  ],
};

const ConnectivityShowcase = {
  eyebrow: "CONNECTIVITY",
  heading: "Stay connected, informed and up to date wherever you go.",
  slides: [
    {
      image: `${SHOWROOM}/conn/RemoteSeat.png`,
      title: "Remote Seat Ventilation Control",
      subtitle:
        "Get the cabin ready before you get in. Switch on seat ventilation remotely and step into a cooler, more comfortable drive.",
    },
    {
      image: `${SHOWROOM}/conn/SVM.png`,
      title: "Find My Car with SVM",
      subtitle:
        "Can’t remember where you parked? Let your Sorento help you find it. SVM gives you a clearer view of your vehicle’s surroundings, making it easier to locate your car.",
    },
    {
      image: `${SHOWROOM}/conn/Over-the-Air.png`,
      title: "Over-the-Air Software update for 30 Controllers",
      subtitle:
        "Keep 30 vehicle controllers updated with software improvements, conveniently over the air-no workshop visit required.",
    },
    {
      image: `${SHOWROOM}/conn/Kia_ai.png`,
      title: "Kia AI Assistant with Real-time Generative AI capabilities",
      subtitle:
        "Just ask, and let your Sorento do the thinking. The Kia AI Assistant understands your questions, keeps the conversation going and gives you real-time answers.",
    },
    {
      image: `${SHOWROOM}/conn/Immobilization.png`,
      title: "Remote Vehicle Immobilization",
      subtitle:
        "Add an extra layer of security, even when you’re away from your Sorento. Remotely immobilise the vehicle when needed, giving you greater control and peace of mind.",
    },
    {
      image: `${SHOWROOM}/conn/Digital_Key.png`,
      title: "Digital Key 2.0",
      subtitle:
        "Leave your physical key behind and keep your Sorento with you on your smartphone. Lock, unlock and access your vehicle with the convenience of a digital key.",
    },
  ],
};

const AdasShowcase = {
  eyebrow: "ADAS",
  heading: "An extra layer of confidence, every drive.",
  slides: [
    {
      image: `${SHOWROOM}/adas/LaneKeepingAssist.png`,
      title: "Lane Keeping Assist (LKA)",
      subtitle:
        "Stay confidently in your lane, even when the road gets busy. Intelligent assistance helps keep your Sorento centred for a more controlled drive.",
    },
    {
      image: `${SHOWROOM}/adas/ForwardCollisionWarning.png`,
      title: "Forward Collision Warning and Avoidance Assist (FCW & FCA)",
      subtitle:
        "Stay alert to what’s ahead and respond with greater confidence. Intelligent assistance helps detect potential collisions and supports you when it matters most.",
    },
    {
      image: `${SHOWROOM}/adas/DriverAttentionWarning.png`,
      title: "Driver Attention Warning (DAW)",
      subtitle:
        "Stay focused on the road and confident behind the wheel. Intelligent monitoring helps detect signs of driver fatigue or inattention when you need it most.",
    },
    {
      image: `${SHOWROOM}/adas/BlindViewMonitor.png`,
      title: "Blind View Monitor in Cluster (BVM)",
      subtitle:
        "See what’s beside you without taking your eyes off the road. A clearer view of your blind spots helps you change lanes with greater confidence.",
    },
  ],
};

// Swatch colours used in the trim cards
const ABP = "#151617"; // Aurora Black Pearl
const GWP = "#f3f9fb"; // Glacier White Pearl
const MRD = "#7b1e24"; // Magma Red
const ISG = "#c9c7bf"; // Ivory Silver Gloss
const KDG = "#8f9599"; // Gravity Grey
const IBU = "#1f2e4d"; // Imperial Blue
const PWO = "#3e493b"; // Pewter Olive
const DGM = "#3b3d40"; // Dark Gun Metal (Matte)

const VariantData = [
  {
    name: "HTE 7",
    price: "27,99,000",
    colors: [ABP, GWP, MRD, ISG, KDG, IBU, PWO],
    features: [
      "Smoky Black & Grey Two Tone Interior & Leatherette Seats",
      "Crystal Cube MFR LED Headlamps with Auto Light Control",
      "Electric Adjust Outside Mirrors with Power Fold & LED Indicator",
      "10-Way Driver Power Seat with Lumbar",
      "Dual Zone Automatic Temperature Control",
      "31.24cm (12.3”) HD Touchscreen & 6 Speakers",
      "26 Standard Safety Pack (w/ 7 Airbags)",
    ],
  },
  {
    name: "HTE(O) 7",
    price: "29,49,000",
    colors: [ISG, KDG, MRD, GWP, IBU, PWO, ABP],
    features: [
      "Dual Pane Panoramic Sunroof",
      "Front Ventilated Seats with 3-Step Cooling",
      "Smart Power Tailgate",
      "8-Way Passenger Power Seat",
      "R18- 46.20 cm (18”) Sporty Crystal Cut Alloy Wheel",
      "Paddle Shifters & SBW Dial Type (Hybrid only)",
      "Auto Defogger with Rain sensing Aero Wiper",
    ],
  },
  {
    name: "HTK 7",
    price: "32,49,000",
    colors: [ABP, IBU, GWP, ISG, PWO, MRD, KDG],
    features: [
      "Panoramic Curved Display Panel (12.3-inch HD Touchscreen and 12.3-inch HD Display Instrument Cluster)",
      "Crystal Cube LED Projection Headlamps with LED Tail Lamps & LED MFR Fog Lamps",
      "R19- 48.2 cm (19”) Premium Crystal Cut Alloy Wheels",
      "Ambient Lighting & 12-Speaker Bose Sound System",
      "Kia Connect 2.0 with OTA Software Updates",
      "360 Degree Camera with Blind View Monitor & 12 Parking Sensors",
      "Robust Front & Rear Skid Plate with Satin Chrome Finish",
    ],
  },
  {
    name: "HTK(A) 7",
    price: "33,49,000",
    colors: [MRD, GWP, ISG, KDG, IBU, PWO, ABP],
    features: [
      "ADAS Level 2 with 21 Autonomous Features",
      "Panoramic Curved Display Panel (12.3-inch HD Touchscreen and 12.3-inch HD Display Instrument Cluster)",
      "Crystal Cube LED Projection Headlamps with LED Tail Lamps & LED MFR Fog Lamps",
      "R19- 48.2 cm (19”) Premium Crystal Cut Alloy Wheels",
      "Ambient Lighting & 12-Speaker Bose Sound System",
      "Kia Connect 2.0 with OTA Software Updates",
      "360 Degree Camera with Blind View Monitor & 12 Parking Sensors",
    ],
  },
  {
    name: "HTX 6",
    price: "37,49,000",
    colors: [DGM, GWP, KDG, IBU, ISG, ABP, PWO, MRD],
    features: [
      "All Wheel Drive with Terrain Mode (Snow, Sand & Mud)",
      "Panoramic Curved Display Panel (12.3-inch HD Touchscreen Navigation Cockpit and 12.3-inch HD Display Instrument Cluster)",
      "Premium Black & Olive Brown Two Tone Interior Leatherette Seats with Embossed Seat Covering",
      "10-Way Powered front seats with Lumbar & Relaxation function, Rear Ventilated Seats",
      "Driver Seat Ergo Function & Memory with ORVM & HUD",
      "Digital IRVM, Head-Up Display, Remote Smart Parking Assist",
      "Kia AI Assistant (Real-time Generative AI) with Voice Command",
    ],
  },
  {
    name: "HTX(A) 6",
    price: "38,49,000",
    colors: [DGM, PWO, ISG, KDG, IBU, GWP, MRD, ABP],
    features: [
      "ADAS Level 2+ with 29 Autonomous Features",
      "10 Airbags (RSAB & CSAB added)",
      "Rear Ventilated Seats with 3-Step Cooling",
      "4-Way Power Boss Mode",
      "Digital Key 2.0 w/ Pocket Lighting",
      "Smart Dashcam with Front & Rear Camera",
      "Wing-type Headrest (Captain Seats), Sliding Headrests for Front",
    ],
  },
];

const ProductFilm = {
  title: "Meet the Kia Sorento",
  subtitle:
    "The global icon has arrived in its most evolved expression yet. Watch the product film now.",
  videoId: "VlMb1Ps2guA",
};

const EvolutionData = {
  heading: "The Evolution of the Global Icon",
  items: [
    {
      year: "2002",
      title: "The First Generation",
      image: `${TEASER}/2002.png`,
      description:
        "Sorento has been the cornerstone of Kia's D-SUV lineup since its debut, blending SUV-grade safety with passenger car comfort. From the start, it signaled the arrival of Kia's signature SUV, expanding into global markets, particularly in North America and Europe, and showcasing the brand's potential on the world stage.",
    },
    {
      year: "2009",
      title: "The Second Generation",
      image: `${TEASER}/2009.png`,
      description:
        "The second-generation Sorento was Kia's first U.S.-built vehicle for the North American market. With Kia's signature Tiger Nose Grille and refined, clean lines, it offered a sleek presence and served as a strategic model that boosted brand recognition, particularly in the region.",
    },
    {
      year: "2014",
      title: "The Third Generation",
      image: `${TEASER}/2014.png`,
      description:
        "The third-generation Sorento was a premium evolution of Kia's flagship SUV, offering elevated design, refinement, and features. With consistent global sales, it strengthened Kia's global standing while serving as the brand's top-tier SUV.",
    },
    {
      year: "2020",
      title: "The Fourth Generation",
      image: `${TEASER}/2020.png`,
      description:
        "The fourth-generation Sorento has long been a core model in Kia's lineup, symbolizing the brand's technology, design, and world-class quality. With midsize SUV space and upscale refinement, it combined mass appeal with a premium feel, while also offering HEV and Diesel powertrains.",
    },
  ],
};

const LovedByWorldData = {
  heading: "Loved by the World",
  images: [`${TEASER}/IMG_3665.jpeg`, `${TEASER}/IMG_3664.jpeg`, `${TEASER}/IMG_3666.jpeg`],
};

const AwardsData = {
  heading: "Recognized. Awarded. Celebrated.",
  tabs: [
    {
      label: "Design",
      mobileImage: `${TEASER}/d-m.jpg`,
      images: [`${TEASER}/d1.jpg`, `${TEASER}/d2.jpg`, `${TEASER}/d3.jpg`, `${TEASER}/d4.jpg`],
    },
    {
      label: "Safety",
      mobileImage: `${TEASER}/s-m.jpg`,
      images: [`${TEASER}/s1.jpg`, `${TEASER}/s2.jpg`, `${TEASER}/s3.jpg`, `${TEASER}/s4.jpg`],
    },
    {
      label: "Style & Performance",
      mobileImage: `${TEASER}/st-m.jpg`,
      images: [`${TEASER}/s11.jpg`, `${TEASER}/s22.jpg`, `${TEASER}/s33.jpg`, `${TEASER}/s44.jpg`],
    },
  ],
};

const DetailInfo = [
  {
    bgColor: "#FFF",
    color: "#000",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/calendar%20(1).png?alt=media&token=20b23e49-7a08-4369-82ae-a0277d5f2e9e",
    title: "Book Now The Kia Sorento",
    desc: "A global icon is ready to make its mark in India. Be among the first to experience what’s next.",
    link: "",
  },
  {
    bgColor: "#05141f",
    color: "#FFF",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/download.png?alt=media&token=9de03b22-8ba2-433e-9ff0-a78165faaf3a",
    title: "Download Brochure",
    desc: "Explore the Kia Sorento’s design, technology, performance and premium features in detail.",
    link: BrochureLink,
  },
  {
    bgColor: "#FFF",
    color: "#000",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/calendar%20(1).png?alt=media&token=20b23e49-7a08-4369-82ae-a0277d5f2e9e",
    title: "Call us for more information",
    desc: "Have questions about the Kia Sorento? Our team is here to help. 1800 108 5000",
    link: "tel:+911800108500",
  },
];

export {
  BannerData,
  BrochureLink,
  LifestyleImage,
  HighlightsData,
  CircleData,
  ExploreVideoData,
  ExteriorShowcase,
  InteriorShowcase,
  SafetyShowcase,
  ComfortShowcase,
  ConnectivityShowcase,
  AdasShowcase,
  VariantData,
  ProductFilm,
  EvolutionData,
  LovedByWorldData,
  AwardsData,
  DetailInfo,
};
